import { render, staticRenderFns } from "./addIdModal.vue?vue&type=template&id=297f1f52&scoped=true"
import script from "./addIdModal.vue?vue&type=script&lang=js"
export * from "./addIdModal.vue?vue&type=script&lang=js"
import style0 from "./addIdModal.vue?vue&type=style&index=0&id=297f1f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297f1f52",
  null
  
)

export default component.exports